import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme, ZIndexLayer } from "shared/lib/styles";

type FloatingButtonProps = {
  $hasTooltip?: boolean;
  $takeoverOffset?: string;
};

export const FloatingButtonWrapper = styled.div<FloatingButtonProps>`
  position: fixed;
  inset-block-end: 24px;
  inset-inline-end: 24px;
  z-index: ${ZIndexLayer.TypeformFloatingButton};

  display: flex;
  gap: 8px;
  align-items: center;

  padding-block: 8px;
  padding-inline: 16px 8px;

  border-radius: 100px;

  background-color: #ffca05;

  box-shadow: 0 2px 8px rgb(0 0 0 / 0.15);

  cursor: pointer;

  ${props =>
    props.$takeoverOffset
      ? css`
          inset-block-end: ${props.$takeoverOffset};
        `
      : ""}

  ${props =>
    props.$hasTooltip
      ? css`
          padding-inline: 8px;
          ${theme.breakpoints.up("tablet")} {
            padding-inline: 16px 8px;
          }
        `
      : css`
          padding-inline: 8px;
        `}

  ${theme.breakpoints.down("tablet")} {
    inset-block-end: 16px;
    inset-inline-end: 16px;
  }
`;

export const TooltipLabel = styled.div`
  display: none;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 100%;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const FloatingButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 40px;
  block-size: 40px;
  padding: 0;

  border: none;
  border-radius: 50%;

  background-color: #001246;

  cursor: pointer;

  svg {
    inline-size: 24px;
    block-size: 24px;

    fill: #ffca05;
  }
`;

export const PopupOverlay = styled.div`
  position: fixed;
  inset-block: 0;
  inset-inline: 0;
  z-index: ${ZIndexLayer.TypeformPopupOverlay};

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgb(0 0 0 / 0.5);
`;

export const PopupContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  inline-size: 90vw;
  block-size: 580px;
  max-inline-size: 800px;

  border-radius: 8px;

  background-color: #ffffff;

  box-shadow: 0 4px 24px rgb(0 0 0 / 0.2);

  ${theme.breakpoints.down("tablet")} {
    inline-size: 95vw;
  }
`;

export const PopupIframe = styled.iframe`
  flex: 1;

  inline-size: 100%;
  block-size: 100%;

  border: none;
  border-radius: 8px;
`;

export const CloseButton = styled.button`
  position: absolute;
  inset-block-start: -12px;
  inset-inline-end: -12px;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 32px;
  block-size: 32px;
  padding: 0;

  border: none;
  border-radius: 50%;

  background-color: #ffffff;

  box-shadow: 0 2px 4px rgb(0 0 0 / 0.2);

  cursor: pointer;

  transition:
    transform 0.15s ease,
    background-color 0.15s ease;

  &:hover {
    background-color: #f5f5f5;

    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }

  svg {
    inline-size: 16px;
    block-size: 16px;

    fill: #333333;
  }
`;
